import React from "react";
import { useTranslation } from "react-i18next";

import { MunicipalityData } from "../../../../../models/MunicipalityData";
import DropdownSelect from "../../../../FormElement/DropdownSelect";
import { useCities, usePrefectures } from "../../hooks";

import "./styles.scss";

export interface IPrefectureCitySelectProps {
  prefecture: MunicipalityData | undefined;
  city: MunicipalityData | undefined;
  onChangePrefecture: (prefecture: MunicipalityData | undefined) => void;
  onChangeCity: (city: MunicipalityData | undefined) => void;
}

export const PrefectureCitySelect: React.FunctionComponent<
  IPrefectureCitySelectProps
> = ({ prefecture, city, onChangePrefecture, onChangeCity }) => {
  const { t: _t } = useTranslation();
  const t = (key: string) =>
    _t(`internalToolsHomePage.gbp_places_query.form.${key}`);

  const { data: prefectures } = usePrefectures();
  const { data: cities } = useCities(prefecture?.external_id);

  const handleChangePrefecture = (name: string) => {
    const selected = prefectures?.find((item) => item.name === name);
    onChangePrefecture(selected);
    onChangeCity(undefined);
  };

  const handleChangeCity = (name: string) => {
    const selected = cities?.find((item) => item.name === name);
    onChangeCity(selected);
  };

  return (
    <div className="prefecture-city-select">
      <div className="prefecture-city-select-field">
        <div className="label-txt">{t("prefecture_label")}</div>
        <DropdownSelect
          value={prefecture?.name ?? ""}
          items={(prefectures ?? []).map((item) => item.name)}
          translationKey="internalToolsHomePage.gbp_places_query.form"
          placeholder="prefecture_placeholder"
          onChange={handleChangePrefecture}
        />
      </div>
      <div className="prefecture-city-select-field">
        <div className="label-txt">{t("city_label")}</div>
        <div className="prefecture-city-select-input-row">
          <DropdownSelect
            value={city?.name ?? ""}
            items={(cities ?? []).map((item) => item.name)}
            translationKey="internalToolsHomePage.gbp_places_query.form"
            placeholder={
              prefecture ? "city_placeholder" : "city_placeholder_disabled"
            }
            isDisabled={!prefecture}
            onChange={handleChangeCity}
          />
          {city && (
            <button
              type="button"
              className="btn btn-border prefecture-city-select-clear"
              onClick={() => onChangeCity(undefined)}
            >
              {t("city_clear")}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default PrefectureCitySelect;
